<template>
  <div>
    <a-card size="small" title="配置元数据">
        <div slot="extra" style="width:200px">
            <a-button type="primary" @click="handleNew" class="fr mr20">新增</a-button>
            <rangerule :platformcode="platformcode" :isconfig="true" class="fr mr20"></rangerule>
        </div>
        <searchE @handleSearch="handleSubmit"></searchE>
        <tableE ref="cloudconfigTableID"></tableE>

    </a-card>

     
  </div>
</template>
<script>
import rangerule from '../com/rangerule'
import searchE from './search'
import tableE from './table'
export default {
    data() {
        return {
            platformcode:''
        };
    },
    methods: {
        handleSubmit(searchP){
            this.platformcode = searchP.platformcode;
            this.$refs.cloudconfigTableID.handleSearch(searchP);
        },
        handleNew(){
            this.$router.push({
                path: "addconfig",
                query: {
                    platformcode:this.platformcode,
                    configcode:''
                }
            });
        },
    },
    components:{
        rangerule,
        searchE,
        tableE
    },
    mounted(){

    }
};
</script>
<style scoped>

</style>
